import { QueryFunctionContext } from '@tanstack/react-query';
import { makeRequestToSaveForLaterODM } from 'common/save-for-later-service';
import { ATGSFLGetItemsResponse } from 'common/types/ATGSFLResponse';

export const getSFLItems = async ({
  queryKey: [, , ,],
}: QueryFunctionContext<[key: 'sfl', isLocal: boolean]>): Promise<ATGSFLGetItemsResponse> => {
  const SFLItems = await makeRequestToSaveForLaterODM();

  return SFLItems;
};
